import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import { Label } from '@src/design-system/label';
import { cn } from '@src/design-system/helpers';

import { EmailIcon } from '@shared/assets/icons/shared/email-icon';

import type { ComponentProps } from 'react';
import type { TUser } from '@shared/types/user';

export function AssigneeInfo({
  avatar,
  id,
  email,
  first_name,
  last_name,
  className,
}: TUser & Omit<ComponentProps<'div'>, 'id'>) {
  const INTERVIEWER_INFO = [
    {
      label: email,
      icon: <EmailIcon />,
    },
  ];
  const name = `${first_name} ${last_name}`;

  if (!id) return null;

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <Avatar className='size-10'>
        <AvatarImage src={avatar} />
        <AvatarFallback colorId={id}>{name.substring(0, 1)}</AvatarFallback>
      </Avatar>
      <div className='w-full flex-1'>
        <Label className='mb-1'>{name}</Label>
        <div className='flex items-center w-[90%] text-gray-600 text-sm'>
          {INTERVIEWER_INFO.map((info) => (
            <div
              key={info.label}
              className='flex items-center mr-4'
            >
              <div className='size-[16px] mr-1'>{info.icon}</div>
              <span
                title={info.label}
                className={cn('whitespace-nowrap', 'truncate')}
              >
                {info.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
